import useUserPermission from "~/hooks/useUserPermission";
import { useAdminGrantsFlag } from "./useAdminGrantsFlag";

// Shows the Administration tab only to holders of `read:admin-grants`
// (Manifold Superusers), so User Managers without it don't see the tab.
export function useCanViewAdminGrants(): boolean {
  const flagEnabled = useAdminGrantsFlag();
  const canReadGrants = useUserPermission("read:admin-grants");
  return flagEnabled && canReadGrants;
}
